<template>
  <div>
    <v-card
      v-if="certs !== undefined"
      class="pa-6"
    >
      <div :class="$style.widget_header_wrapper">
        <span :class="['display-3', $style.widget_title]">Сертификация</span>

        <v-chip
          :class="[$style.chip_wrapper, certs.is_cert ? $style.cert_background : $style.not_cert_background]"
          small
        >
          {{ certs.is_cert ? 'Сертифицирован' : 'Не сертифицирован' }}
        </v-chip>
      </div>

      <Table
        v-if="certs.items.length > 0"
        :class="$style.table"
        :headers="cols"
        :items="certs.items"
        hide-default-footer
        no-data-text="Курсы, удовлетворяющие выбранным параметрам, отсутствуют"
        :not_resizeble="true"
        @click:row="go_to_certificates_page"
      >
        <template v-slot:[`item.in_stock`]="{ item }">
          <td
            class="py-2 font-weight-bold text-center"
            :class="item.in_stock < item.required ? $style.error_count : ''"
          >
            {{ item.in_stock }}
          </td>
        </template>

        <template v-slot:[`item.required`]="{ item }">
          <td class="py-2 font-weight-bold text-center">
            {{ item.required }}
          </td>
        </template>
      </Table>
    </v-card>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Table } from '@/components/global';
import { OptionalCol } from '@/types';
import { Widgets } from '@/components/widgets/types';
import { default_certs } from '@/components/widgets/services';
import { staffs_store } from '@/store';
import { Staffs } from '@/modules/staffs/types';

const { mutations } = staffs_store.modules.staff_certificates_list;

@Component({
  components: {
    Table,
  },
})
export default class WidgetCertifications extends Vue {
  @Prop({ type: Object, default: default_certs() })
  certs!: Widgets.Certs;

  cols: OptionalCol[] = [
    {
      text: 'Название',
      value: 'title',
      sortable: false,
      is_visible: true,
    },
    {
      text: 'Имеется',
      value: 'in_stock',
      width: '100px',
      align: 'center',
      sortable: false,
      is_visible: true,
    },
    {
      text: 'Требуется',
      value: 'required',
      align: 'center',
      width: '100px',
      sortable: false,
      is_visible: true,
    },
  ];

  go_to_certificates_page(certItem: Widgets.CertItem) {
    mutations.UPD_FILTER_KEY({
      key: 'course_id',
      value: certItem.course_id !== undefined && certItem.course_id !== null ? certItem.course_id
        : '',
    });

    this.$router.push({ name: Staffs.Pages.STAFF_CERTIFICATES });
  }
}
</script>

<style module lang="scss">
@import '@/scss/common/filter-blocks.scss';
@import '@/scss/colors.scss';

.widget_title {
  font-style: 24px;
  font-weight: 600;
  line-height: 32px;
  color: #13141C;
}

.widget_header_wrapper {
  display: flex;
  align-items: center;
}

.chip_wrapper {
  margin-left: 16px;
  color: white!important;
}

.not_cert_background {
  background-color: $error_darken4!important;
}

.error_count {
  color: $error_darken4!important;
}

.cert_background {
  background-color: $success_darken2!important;
}

.table {
  margin-top: 24px;

  :global(tr) {
    cursor: pointer;
  }
}
</style>
